import { GuaranteeSeals } from '../components/GuaranteeSeals';
import { HomeHeroCarousel } from '../components/HomeHeroCarousel';
import { Reveal } from '../components/Reveal';
import { ServicesCarousel } from '../components/ServicesCarousel';
import { TrustStrip } from '../components/TrustStrip';
import { GUARANTEES, HOME_HERO_SLIDES, SERVICES } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function HomePage() {
  useDocumentMeta({
    title: 'Corporación Indemniza | Especialistas en indemnizaciones',
    description: 'Especialistas exclusivos en reparación y compensación legal de daños, negligencias médicas, contratos y conciliación.',
    canonicalPath: '/',
  });

  const [featured, ...otherServices] = SERVICES;

  return (
    <div className="home-page">
      <h1 className="sr-only">Corporación Indemniza: especialistas en indemnizaciones</h1>
      <HomeHeroCarousel slides={HOME_HERO_SLIDES} />
      <TrustStrip />

      <section className="home-services" aria-labelledby="home-services-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--light">
            <p className="eyebrow">Nuestras especialidades</p>
            <h2 id="home-services-title">Te ayudamos ante daños e incumplimientos <span>cuando más lo necesitas.</span></h2>
            <p>Somos especialistas exclusivos en indemnizaciones. Encuentra el área que necesitas.</p>
          </Reveal>

          <Reveal as="article" className="featured-service" delay={70}>
            <div className="featured-service__image"><img src={featured.image} alt="Profesional revisando una radiografía con sus clientes" loading="lazy" /></div>
            <div className="featured-service__body">
              <p className="eyebrow">Especialidad destacada</p>
              <h3>{featured.title}</h3>
              <p>{featured.description}</p>
            </div>
          </Reveal>

          <Reveal delay={120}><ServicesCarousel items={otherServices} /></Reveal>
        </div>
      </section>

      <section className="home-seals" aria-labelledby="home-seals-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--light section-intro--compact">
            <p className="eyebrow">Nuestras garantías</p>
            <h2 id="home-seals-title">Sellos de confianza</h2>
            <p>El compromiso que respalda cada caso que asumimos.</p>
          </Reveal>
          <Reveal delay={90}><GuaranteeSeals items={GUARANTEES} /></Reveal>
        </div>
      </section>
    </div>
  );
}
